import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setHasEndDate } from 'products/nomad_insurance/views/Purchase/steps/Coverage/state';
import { StyledSubscriptionCard } from './styled';

const SubscriptionCard = () => {
  const dispatch = useDispatch();
  const { hasEndDate, numberOfDays } = useSelector(
    // @ts-ignore state is not typed
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  // @ts-ignore state is not typed
  const { personalOffer } = useSelector((state) => state.nomadInsurance.application);

  if (!(numberOfDays > 28 && hasEndDate)) {
    return null;
  }

  return (
    <StyledSubscriptionCard>
      Or you can pay <b>${personalOffer?.fourWeekPrice} every 4 weeks</b> and stop at
      anytime.{' '}
      <button
        type="button"
        onClick={() => {
          dispatch(setHasEndDate(false));
        }}
      >
        Select this option
      </button>
    </StyledSubscriptionCard>
  );
};

export default SubscriptionCard;
